import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AbChatbotLandingPageComponent } from './bot-ui/ab-chatbot-landing-page/ab-chatbot-landing-page.component';
import { ChatLoaderComponent } from './bot-ui/chat-loader/chat-loader.component';
import { AIChatLoaderComponent } from './bot-ui/ai-chat-loader/ai-chat-loader.component';
import { botUIRoutes } from './bot-ui/bot-ui-routes';
import { aiModuleroutes } from './ai-module/ai-routes';
import { chatwithExpertroutes } from './chat-with-expert/chat-with-expert-routes';



export const routes: Routes = [{ path: '', redirectTo: 'chatloader', pathMatch: 'full' },
{ path: 'chatloader', component: ChatLoaderComponent },
{ path: 'aiChatloader', component: AIChatLoaderComponent },
{ path: 'chatlanding', component: AbChatbotLandingPageComponent },
{
  path: 'chat',
  children: botUIRoutes
},
{
  path: 'liveChat',
  children: chatwithExpertroutes
},
{
  path: 'aiHelp',
  children: aiModuleroutes
}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    scrollPositionRestoration: 'enabled', // scroll to top on each page up
    anchorScrolling: 'enabled',
    enableTracing: false
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
